import * as React from 'react';
import { Col, Row, Alert, Spinner } from 'react-bootstrap';
import { EventExtendedView } from 'cb-model';
import { Filter, QueryOptions } from 'gossamer-unified';
import { EventTileFromRow } from 'shared-front-end';
import { useCacheQuery } from 'gossamer-front-end';

interface Props {
  institutionId?: number;
  title?: string;
  emptyText?: string;
  where?: QueryOptions['where'];
}

const defaultQuery = (institutionId?: number, where?: QueryOptions['where']): QueryOptions => ({
  where:
    institutionId || where
      ? {
          and: [
            ...(institutionId
              ? ([{ fieldId: 'institution_id', operator: 'eq', value: String(institutionId) }] as Filter[])
              : []),
            ...(where?.and || []),
          ],
        }
      : { and: [] },
  order: [['start_at', 'DESC']],
  offset: 0,
  limit: 24,
});

export const WebsiteEventsPage = ({
  institutionId,
  emptyText = 'No events found.',
  where,
}: Props): React.JSX.Element => {
  const query = React.useMemo(() => defaultQuery(institutionId, where), [institutionId, where]);
  const events = useCacheQuery(EventExtendedView, query);

  return (
    <>
      {events.isFetching && <Spinner animation="border" />}
      {events.error && <Alert variant="danger">Failed to load events.</Alert>}
      {!events.isFetching && !events.error && (!events.data || events.data.length === 0) && (
        <Alert variant="light">{emptyText}</Alert>
      )}
      <Row xs={1} md={2} lg={3} className="g-3">
        {events.data?.map((item) => (
          <Col key={item.id}>
            <EventTileFromRow item={item} />
          </Col>
        ))}
      </Row>
    </>
  );
};
